import { useCallback } from "react";

import { trackEvent } from "@is/services/EventTracking";

import { AccordionItemType } from "../Accordion.types";

type Props = {
  item: AccordionItemType;
  onClick: (id: string) => void;
  isExpanded: boolean;
};

const useManageAccordionItem = ({ item, onClick, isExpanded }: Props) => {
  const handleClick = useCallback(() => {
    if (
      item?.trackingData &&
      Object.keys(item?.trackingData)?.length &&
      !isExpanded
    ) {
      trackEvent(item?.trackingData);
    }

    onClick(item.id);
  }, [item, isExpanded, onClick]);

  return {
    handleClick,
  };
};

export default useManageAccordionItem;
